<div class="document-upload">
  <app-upload-document
    #uploadDocument
    [optionalFilesTitle]="'upload.optionalActionPlans'"
    [documentType]="DocumentTypeEnum.ACTION_PLAN"
  ></app-upload-document>
  <div class="options">
    <button
      mat-flat-button
      [disabled]="isVerifyDisabled"
      [class.disabled]="isVerifyDisabled"
      (click)="verifyActionPlan()"
    >
      {{ 'stepper.verifyActionPlan' | translate }}
    </button>
  </div>
</div>
@if (actionPlanExists) {
  @if (actionPlanVerdictError) {
    <app-rerun-task (rerun)="rerun.emit()"></app-rerun-task>
  } @else {
    @if (actionPlanVerdict) {
      <div class="action-plan-verdict">
        <p>
          {{ actionPlanVerdict }}
        </p>

        <app-work-process-selector
          [preselected]="preselectedWorkProcess"
          (workProcessSelected)="workProcessSelected.emit($event)"
        ></app-work-process-selector>

        <div class="action-buttons">
          <button
            mat-stroked-button
            [disabled]="!canUpload || isUploadInProgress || uploadDone"
            [class.disabled]="!canUpload || isUploadInProgress || uploadDone"
            (click)="uploadToSsd.emit()"
          >
            {{ 'button.uploadToSsd' | translate }}
          </button>

        </div>
      </div>
    } @else if (isVerifyInProgress) {
      <div class="empty-action-plan-verdict">
        <app-waiting [message]="'stepper.creatingActionPlanVerdict' | translate"></app-waiting>
      </div>
    }
  }
}
